import http from "../../rest/http";

export const fetchApplicationDetails = async () => {
  try {
    const response = await http.get("/api/v1/application/list-all");
    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
    
  }
};

export const removeApplication = async (data: any) => {
  try {
    const response = await http.post(`/api/v1/application/remove-user`, data);
    return response;
  } catch (error) {
    console.error("Error in updating users:", error);
    throw error;
  }
};
